export var DEPLOY_DATE = new Date('2026-10-09T21:31:32+0000');
